import { dk as e, j as x, bQ as g, dd as u, dl as h } from "./form-9P9mR_7r.js";
import { dm as W, dE as _, dp as C, dn as H, dq as S, ds as z, dr as A, dx as B, dt as F, dw as D, du as E, dv as V, dy as q, dz as G, dC as J, dA as K, dD as M, dB as R, dG as O, dH as P, dM as U, dK as X, dL as Y, dI as Z, dJ as $, dF as ee } from "./form-9P9mR_7r.js";
import { jsxs as s, jsx as l } from "react/jsx-runtime";
const w = ({ logo: a, search: i, actions: n, cockpit: t, ...c }) => /* @__PURE__ */ s("header", { className: e("flex w-full items-center justify-between gap-16"), ...c, children: [
  a,
  i || n || t ? /* @__PURE__ */ s("div", { className: e("flex items-center gap-8"), children: [
    i ? /* @__PURE__ */ l("div", { className: e("flex items-center gap-16 max-md:hidden"), children: i }) : null,
    n ? /* @__PURE__ */ l("div", { className: e("max-md:hidden"), children: n }) : null,
    t
  ] }) : null
] }), b = ({ details: a, reference: i, status: n, timeline: t, actions: c, children: d, ...r }) => /* @__PURE__ */ l(x, { ...r, children: /* @__PURE__ */ s("div", { className: e("flex w-full flex-col gap-16"), children: [
  /* @__PURE__ */ s("div", { className: e("flex flex-col gap-16 lg:flex-row lg:items-center"), children: [
    /* @__PURE__ */ l("div", { className: e("flex flex-col gap-4", "lg:w-[140px] lg:shrink-0"), children: a }),
    /* @__PURE__ */ l("div", { className: e("flex flex-col gap-4", "lg:w-32 lg:shrink-0", "[&_*]:truncate"), children: i }),
    /* @__PURE__ */ l("div", { className: e("flex flex-col gap-4", "lg:w-[140px] lg:shrink-0 lg:items-center lg:justify-center"), children: n }),
    /* @__PURE__ */ l("div", { className: e("flex min-w-0 grow flex-col gap-12"), children: t }),
    /* @__PURE__ */ l("div", { className: e("flex shrink-0 gap-4", "lg:w-[140px] lg:justify-end"), children: c })
  ] }),
  d ? /* @__PURE__ */ l("div", { className: e("flex flex-col"), children: d }) : null
] }) }), T = ({ children: a }) => /* @__PURE__ */ l("div", { className: e("flex w-full flex-col gap-8", "lg:flex-row lg:items-center"), children: a }), y = () => /* @__PURE__ */ l("div", { className: e("flex"), children: /* @__PURE__ */ l("div", { className: e("flex", "max-lg:rotate-90"), children: /* @__PURE__ */ l(g, { name: "ArrowRight" }) }) }), k = ({ prefix: a, children: i }) => /* @__PURE__ */ s("div", { className: e("flex w-full items-center gap-8"), children: [
  a ? /* @__PURE__ */ l("div", { className: e("flex"), children: a }) : null,
  /* @__PURE__ */ l("div", { className: e("flex", "lg:w-48", "[&_*]:line-clamp-2"), children: /* @__PURE__ */ l(u, { variant: "small", children: i }) })
] }), I = ({
  details: a,
  reference: i,
  status: n,
  timeline: t,
  actions: c,
  children: d,
  href: r,
  target: m,
  onClick: o,
  ...f
}) => /* @__PURE__ */ l(
  r || o ? "a" : "div",
  {
    className: e(
      "block",
      "bg-card-background text-card-text relative flex w-full flex-col overflow-hidden border shadow-xs",
      "focus-visible:ring-ring focus-visible:ring-2 focus-visible:outline-hidden",
      { "cursor-pointer": o }
    ),
    onClick: o,
    href: r,
    target: m,
    ...f,
    children: /* @__PURE__ */ l("div", { className: e("flex flex-col gap-16 p-4"), children: /* @__PURE__ */ s("div", { className: e("flex w-full flex-col gap-16"), children: [
      /* @__PURE__ */ s("div", { className: e("flex flex-col gap-16 lg:flex-row lg:items-center"), children: [
        /* @__PURE__ */ l("div", { className: e("flex flex-col gap-4", "lg:w-[140px] lg:shrink-0", "[&_*]:truncate"), children: a }),
        /* @__PURE__ */ l("div", { className: e("flex flex-col gap-4", "lg:w-[120px] lg:shrink-0", "[&_*]:truncate"), children: i }),
        /* @__PURE__ */ l(
          "div",
          {
            className: e(
              "flex flex-col gap-4",
              "lg:w-[140px] lg:shrink-0 lg:items-center lg:justify-center",
              "[&_*]:truncate",
              "[&_*]:max-w-full"
            ),
            children: n
          }
        ),
        /* @__PURE__ */ l("div", { className: e("flex min-w-0 grow"), children: t }),
        /* @__PURE__ */ l("div", { className: e("flex shrink-0 gap-4"), children: c })
      ] }),
      d ? /* @__PURE__ */ l("div", { className: e("flex flex-col"), children: d }) : null
    ] }) })
  }
), j = ({ children: a, ...i }) => /* @__PURE__ */ s(
  "div",
  {
    className: e(
      "bg-surface-background-default relative flex min-h-screen grow flex-col items-center justify-center"
    ),
    ...i,
    children: [
      /* @__PURE__ */ l("div", { className: e("relative z-10 flex w-full flex-col items-center p-4"), children: /* @__PURE__ */ l("div", { className: e("flex w-full max-w-96 flex-col gap-8"), children: a }) }),
      /* @__PURE__ */ l(
        "img",
        {
          src: h,
          alt: "",
          className: e(
            "pointer-events-none absolute top-0 right-0 h-[400px] -translate-y-1/4 transform",
            "lg:h-[800px]"
          )
        }
      )
    ]
  }
);
export {
  W as Brand,
  w as Header,
  _ as HorizontalTimeline,
  C as Layout,
  H as LayoutVariant,
  S as Navigation,
  z as NavigationItem,
  A as NavigationList,
  B as Notification,
  F as Notifications,
  D as NotificationsFooter,
  E as NotificationsHeader,
  V as NotificationsList,
  b as Quote,
  q as QuoteExpandable,
  T as QuoteTimeline,
  k as QuoteTimelineItem,
  y as QuoteTimelineSeparator,
  I as Shipment,
  j as Splash,
  G as StatusIcon,
  J as TimeLineItemContent,
  K as Timeline,
  M as TimelineDataType,
  R as TimelineItem,
  O as VerticalTimeline,
  P as Widget,
  U as WidgetActionItem,
  X as WidgetContent,
  Y as WidgetFooter,
  Z as WidgetHeader,
  $ as WidgetTitle,
  ee as renderTimelineItemContent
};
